import React from "react";
import { UserInformationSection, UserInfoBadge } from "./styled";
import { format } from "date-fns";
import { getFullName, renderValue } from "utils/renderCompanyCell";
import StatusPillButtons from "components/Buttons/StatusPillButtons";

export const ProfileOverview = ({ marketUserDetails }) => {
  return (
    <>
      <UserInformationSection>
        <h3 className="section-title">Identity & Contact Information</h3>
        <ul className="user-details-grid">
          <li>
            <span>Name</span>
            <div className="profile-info">
              {marketUserDetails?.profile_image && (
                <img src={marketUserDetails.profile_image} alt="Profile" />
              )}
              <p>{renderValue(getFullName(marketUserDetails))}</p>
            </div>
          </li>
          <li>
            <span>Login Phone Number</span>
            <p>
              {marketUserDetails?.phone_number
                ? `+91 ${marketUserDetails.phone_number}`
                : "-"}
            </p>
          </li>
          <li>
            <span>Phone verified at</span>
            <p>
              {renderValue(
                marketUserDetails?.phone_verified_at
                  ? format(
                      new Date(marketUserDetails.phone_verified_at),
                      "MMM dd, yyyy h:mm a"
                    )
                  : "-"
              )}
            </p>
          </li>
          <li>
            <span>Email</span>
            <div className="profile-info">
              <p>{renderValue(marketUserDetails?.email)}</p>
            </div>
          </li>
          <li>
            <span>Email verified at</span>
            <p>
              {renderValue(
                marketUserDetails?.email_verified_at
                  ? format(
                      new Date(marketUserDetails.email_verified_at),
                      "MMM dd, yyyy h:mm a"
                    )
                  : "-"
              )}
            </p>
          </li>
          <li>
            <span>Email Updated</span>
            <StatusPillButtons
              status={marketUserDetails?.email_updated ? "Yes" : "No"}
            />
          </li>
          <li>
            <span>LinkedIn URL</span>
            {marketUserDetails?.linkedin_url ? (
              <a
                href={marketUserDetails?.linkedin_url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {marketUserDetails?.linkedin_url}
              </a>
            ) : (
              <p>-</p>
            )}
          </li>
        </ul>
      </UserInformationSection>

      <UserInformationSection>
        <h3 className="section-title">Account Status & System Metadata</h3>
        <ul className="user-details-grid">
          <li>
            <span>Status</span>
            <StatusPillButtons status={marketUserDetails?.status} />
          </li>
          <li>
            <span>Profile completion %</span>
            <p>
              {marketUserDetails?.profile_completion_percentage
                ? `${marketUserDetails.profile_completion_percentage}%`
                : "-"}
            </p>
          </li>
          <li>
            <span>Approval type</span>
            <p>
              {marketUserDetails?.approval_type
                ? marketUserDetails.approval_type.replaceAll("_", " ")
                : "-"}
            </p>
          </li>
          <li>
            <span>Approval type updated</span>
            <div className="profile-info">
              <StatusPillButtons
                status={marketUserDetails?.approval_type_updated ? "Yes" : "No"}
              />
            </div>
          </li>
          <li>
            <span>Created at</span>
            <p>
              {renderValue(
                marketUserDetails?.created_at
                  ? format(
                      new Date(marketUserDetails.created_at),
                      "MMM dd, yyyy h:mm a"
                    )
                  : "-"
              )}
            </p>
          </li>
          <li>
            <span>Activated at</span>
            <p>
              {renderValue(
                marketUserDetails?.activated_at
                  ? format(
                      new Date(marketUserDetails.activated_at),
                      "MMM dd, yyyy h:mm a"
                    )
                  : "-"
              )}
            </p>
          </li>
          <li>
            <span>Updated at</span>
            <p>
              {renderValue(
                marketUserDetails?.updated_at
                  ? format(
                      new Date(marketUserDetails.updated_at),
                      "MMM dd, yyyy h:mm a"
                    )
                  : "-"
              )}
            </p>
          </li>
          <li>
            <span>Last active at</span>
            <p>
              {renderValue(
                marketUserDetails?.last_active_at
                  ? format(
                      new Date(marketUserDetails.last_active_at),
                      "MMM dd, yyyy h:mm a"
                    )
                  : "-"
              )}
            </p>
          </li>
          <li>
            <span>Source</span>
            <p>
              {marketUserDetails?.source
                ? marketUserDetails.source.replaceAll("_", " ")
                : "-"}
            </p>
          </li>
          <li>
            <span>Signup after verified</span>
            <StatusPillButtons
              status={marketUserDetails?.signup_after_verified ? "Yes" : "No"}
            />
          </li>

          <li>
            <span>Invite code</span>
            <p>{renderValue(marketUserDetails?.invite?.invite_code)}</p>
          </li>
          <li>
            <span>Referral source</span>
            <p>{renderValue(marketUserDetails?.referral_source)}</p>
          </li>
          <li>
            <span>Level</span>
            {marketUserDetails?.level ? (
              <UserInfoBadge color="#147AD6" background="#147AD614">
                {marketUserDetails.level}
              </UserInfoBadge>
            ) : (
              "-"
            )}
          </li>
        </ul>
      </UserInformationSection>

      <UserInformationSection>
        <h3 className="section-title">Professional & Company Context</h3>
        <ul className="user-details-grid">
          <li>
            <span>Company name</span>
            <p>{renderValue(marketUserDetails?.company?.company_name)}</p>
          </li>
          <li>
            <span>Company website</span>
            <p>{renderValue(marketUserDetails?.company?.website)}</p>
          </li>
          <li>
            <span>Designation</span>
            <p>{renderValue(marketUserDetails?.designation)}</p>
          </li>
          <li>
            <span>Goal</span>
            <p>{renderValue(marketUserDetails?.goal)}</p>
          </li>
          <li>
            <span>Company working status updated at</span>
            <p>
              {renderValue(
                marketUserDetails?.email_verified_at
                  ? format(
                      new Date(marketUserDetails.email_verified_at),
                      "MMM dd, yyyy h:mm a"
                    )
                  : "-"
              )}
            </p>
          </li>
        </ul>
      </UserInformationSection>
    </>
  );
};
